import { ActivityEventProvider } from './activity-event/providers/activity-event.provider';
import { AuthProvider } from './auth/providers/auth.provider';
import { CapabilityPermissionProvider } from './capability-permission/providers/capability-permission.provider';
import { CapabilityRoleProvider } from './capability-role/providers/capability-role.provider';
import { ManagementFileProvider } from './management-file/providers/management-file.provider';
import { ManagementWebhookProvider } from './management-webhook/providers/management-webhook.provider';
import { ManagementWebhookEventProvider } from './management-webhook-event/providers/management-webhook-event.provider';
import { OrganizationIntegrationProvider } from './organization-integration/providers/organization-integration.provider';
import { OrganizationHoldingProvider } from './organization-holding/providers/organization-holding.provider';
import { OrganizationCompanyProvider } from './organization-company/providers/organization-company.provider';
import { OrganizationStoreProvider } from './organization-store/providers/organization-store.provider';
import { PaymentCollectorProvider } from './payment-collector/providers/payment-collector.provider';
import { PurchaseChannelProvider } from './purchase-channel/providers/purchase-channel.provider';
import { PurchaseOrderProvider } from './purchase-order/providers/purchase-order.provider';
import { OrganizationInvoiceProvider } from './organization-invoice/providers/organization-invoice.provider';
import { UserPersonProvider } from './user-person/providers/user-person.provider';
import { CompanyCollectorIdentifierProvider } from './company-collector-identifier/providers/company-collector-identifier.provider';
import { CompanyCollectorMerchantProvider } from './company-collector-merchant/providers/company-collector-merchant.provider';
import { CompanyCollectorGroupProvider } from './company-collector-group/providers/company-collector-group.provider';
import { FlowDefinitionProvider } from './flow-definition/providers/flow-definition.provider';
import { FlowExecutionProvider } from './flow-execution/providers/flow-execution.provider';
import { CompanyCollectorProvider } from './company-collector/providers/company-collector.provider';
import { PurchaseTransactionProvider } from './purchase-transaction/providers/purchase-transaction.provider';
import { PurchaseFileProvider } from './purchase-file/providers/purchase-file.provider';
import { PurchaseOperationProvider } from './purchase-operation/providers/purchase-operation.provider';
import { PurchaseCommissionProvider } from './purchase-commission/providers/purchase-commission.provider';
import { ReconciliationTransactionProvider } from './reconciliation-transaction/providers/reconciliation-transaction.provider';
import { PurchaseOperationUnreconciledProvider } from './purchase-operation-unreconciled/providers/purchase-operation-unreconciled.provider';
import { CompanyCollectorSchemaProvider } from './company-collector-schema/providers/company-collector-schema.provider';
import { CompanyCollectorCommissionRuleProvider } from './company-collector-commission-rule/providers/company-collector-commission-rule.provider';
import { CompanyCollectorCommissionTariffProvider } from './company-collector-commission-tariff/providers/company-collector-commission-tariff.provider';
import { ReconciliationDashboardProvider } from './reconciliation-dashboard/providers/reconciliation-dashboard.provider';
import { PurchaseDisputeProvider } from './purchase-dispute/providers/purchase-dispute.provider';
import { ManagementReportProvider } from './management-report/providers/management-report.provider';
import { ManagementReportExecutionProvider } from './management-report-execution/providers/management-report-execution.provider';
import { ManagementReportAccountingProvider } from './management-report-accounting/providers/management-report-accounting.provider';
import { ManagementReportAccountingExecutionProvider } from './management-report-accounting-execution/providers/management-report-accounting-execution.provider';
import { ManagementScheduleProvider } from './management-schedule/providers/management-schedule.provider';
import { ManagementScheduleExecutionProvider } from './management-schedule-execution/providers/management-schedule-execution.provider';
import { ExchangeRateProvider } from './exchange-rate/providers/exchange-rate.provider';
import { OrganizationApiKeyProvider } from './organization-api-key/providers/organization-api-key.provider';

export const infrastructureProviders = [
  ...AuthProvider,
  ...OrganizationHoldingProvider,
  ...OrganizationCompanyProvider,
  ...CapabilityRoleProvider,
  ...CapabilityPermissionProvider,
  ...UserPersonProvider,
  ...ActivityEventProvider,
  ...ManagementWebhookProvider,
  ...ManagementWebhookEventProvider,
  ...OrganizationIntegrationProvider,
  ...OrganizationStoreProvider,
  ...PaymentCollectorProvider,
  ...CompanyCollectorProvider,
  ...CompanyCollectorIdentifierProvider,
  ...CompanyCollectorMerchantProvider,
  ...CompanyCollectorGroupProvider,
  ...FlowDefinitionProvider,
  ...FlowExecutionProvider,
  ...PurchaseOrderProvider,
  ...PurchaseTransactionProvider,
  ...OrganizationInvoiceProvider,
  ...PurchaseChannelProvider,
  ...ManagementFileProvider,
  ...PurchaseFileProvider,
  ...PurchaseOperationProvider,
  ...ReconciliationTransactionProvider,
  ...PurchaseCommissionProvider,
  ...PurchaseOperationUnreconciledProvider,
  ...CompanyCollectorSchemaProvider,
  ...CompanyCollectorCommissionRuleProvider,
  ...CompanyCollectorCommissionTariffProvider,
  ...ReconciliationDashboardProvider,
  ...PurchaseDisputeProvider,
  ...ManagementReportProvider,
  ...ManagementReportExecutionProvider,
  ...ManagementReportAccountingProvider,
  ...ManagementReportAccountingExecutionProvider,
  ...ManagementScheduleProvider,
  ...ManagementScheduleExecutionProvider,
  ...ExchangeRateProvider,
  ...OrganizationApiKeyProvider,
];
